((CountdownTimer, $) => {
  'use strict';

  const cacheDom = (options, userOptions) => {
    if (userOptions.countdownElement) {
      options.$countdown = $(userOptions.countdownElement);
    } else {
      options.$countdown = $('.countdown-timer');
    }

    options.$days = options.$countdown.find('[data-countdown-days]');
    options.$hours = options.$countdown.find('[data-countdown-hours]');
    options.$minutes = options.$countdown.find('[data-countdown-minutes]');
    options.$seconds = options.$countdown.find('[data-countdown-seconds]');
  };

  const render = (time, options) => {
    options.$days.text(time.days);
    options.$hours.text(time.hours);
    options.$minutes.text(time.minutes);
    options.$seconds.text(time.seconds);
  };

  const getTimeRemaining = (endtime) => {
    const timezoneOffset = (new Date()).getTimezoneOffset();

    let t = Date.parse(endtime) - Date.parse(new Date());
    let seconds = (Math.floor((t / 1000) % 60)).toString();
    let minutes = (Math.floor((t / 1000 / 60) % 60)).toString();
    let hours = (Math.floor((t / (1000 * 60 * 60)) % 24)).toString();
    let days = (Math.floor(t / (1000 * 60 * 60 * 24))).toString();

    t += (timezoneOffset * 60 * 1000);

    if (parseInt(seconds, 10) > 0 || parseInt(minutes, 10) > 0 || parseInt(hours, 10) > 0 || parseInt(days, 10) > 0) {
      if (seconds.length === 1) {
        seconds = `0${seconds}`;
      }

      if (minutes.length === 1) {
        minutes = `0${minutes}`;
      }

      if (hours.length === 1) {
        hours = `0${hours}`;
      }

      if (days.length === 1) {
        days = `0${days}`;
      }
    } else {
      seconds = '00';
      minutes = '00';
      hours = '00';
      days = '00';
    }

    return {
      total: t,
      days,
      hours,
      minutes,
      seconds
    };
  };

  const setOptions = (options, userOptions) => {
    options.deadline = userOptions.deadline;

    if (userOptions.dst) {
      options.dst = true;
    } else {
      options.dst = false;
    }
  };

  const init = (userOptions) => {
    if (!userOptions) {
      userOptions = {};
    }

    if (userOptions.deadline) {
      const options = {};
      let time;

      cacheDom(options, userOptions);
      setOptions(options, userOptions);
      time = getTimeRemaining(options.deadline);
      render(time, options);
      options.$countdown.show();

      setInterval(() => {
        var time = getTimeRemaining(options.deadline);
        render(time, options);
      }, 1000);
    }
  };

  CountdownTimer.init = init;
})(window.CountdownTimer = window.CountdownTimer || {}, jQuery);
